import React from 'react';
import classes from './SmoPageImage.module.css';



export const SmoPageImage = props => {
    return (
        <div className={classes.icon}>
            <img src={props.image} alt={props.alt} {...props.sx}/>
        </div>
    )
};

